import { View, StyleSheet } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import CustomSpacing from "../../../components/common/layout/CustomSpacing/CustomSpacing";
import { colors } from "../../../styles/design-system";
import { Sparkles } from "lucide-react";

export const ChatIntegration = () => {
  return (
    <View style={styles.container}>
      <CustomText
        style={styles.sectionHeaderTitle}
        text="Integrations"
        accessibilityLabel="Integrations"
        accessibilityRole="text"
        aria-level="2"
        role="heading"
      />
      <CustomSpacing size="s" />
      <CustomText style={styles.sectionHeaderSubTitle} text="Connect Axio with your favorite tools and services" />
      <CustomSpacing size="l" />
      <View style={styles.comingSoon}>
        <View style={styles.iconBorder}>
          <Sparkles size={24} color={colors.grey[400]} />
        </View>
        <CustomText text="Coming soon" style={styles.comingSoonText} />
        <CustomText text="We're working on integrations with popular study tools" style={styles.comingSoonSubtext} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 16,
    padding: 24,
    borderWidth: 1,
    borderColor: "#eaecf0",
    backgroundColor: "#fff",
  },
  sectionHeaderTitle: {
    fontWeight: 600,
    fontSize: 16,
  },
  sectionHeaderSubTitle: {
    color: colors.grey[600],
    fontSize: 14,
  },
  comingSoon: {
    width: "100%",
    backgroundColor: colors.grey[50],
    borderRadius: 32,
    padding: 32,
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  iconBorder: {
    borderRadius: 9999,
    padding: 8,
    backgroundColor: "#eaecf0",
    width: 48,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },
  comingSoonText: {
    color: colors.grey[600],
    fontSize: 14,
    textAlign: "center",
  },
  comingSoonSubtext: {
    color: colors.grey[500],
    fontSize: 12,
    textAlign: "center",
    marginTop: 4,
  },
});
